module.exports = __webpack_public_path__ + "4af5f82fe955d61e10ce7b7aef1a0153.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/regex-classroom.png
// module id = ./assets/thumbnails/regex-classroom.png
// module chunks = 2